'use client';

import {
  Tooltip as AriaTooltip,
  type TooltipProps as AriaTooltipProps,
  TooltipTrigger as AriaTooltipTrigger,
  type TooltipTriggerComponentProps,
  composeRenderProps,
} from 'react-aria-components';

export type TooltipProps = Omit<AriaTooltipProps, 'children'> & {
  children: React.ReactNode;
};

export function Tooltip({ offset = 8, ...props }: TooltipProps) {
  return (
    <AriaTooltip
      {...props}
      offset={offset}
      className={composeRenderProps(props.className, (className) =>
        [
          'max-w-56 rounded-3 bg-bds-gray-100 px-2.5 py-1.5 ring ring-black/6 shadow-sm',
          'text-label-regular text-bds-gray-0',
          'outline-none',
          'origin-(--trigger-anchor-point)',
          'transition-[opacity,scale] ease-out',
          'duration-135 data-entering:opacity-0 data-entering:scale-95',
          'data-exiting:duration-75 data-exiting:opacity-0 data-exiting:scale-95',
          className,
        ]
          .filter(Boolean)
          .join(' ')
      )}
    />
  );
}

export type TooltipTriggerProps = TooltipTriggerComponentProps;

export function TooltipTrigger({ closeDelay = 0, ...props }: TooltipTriggerProps) {
  return <AriaTooltipTrigger closeDelay={closeDelay} {...props} />;
}
